import logoImg from "../../assets/images/Logo-light.png";
import Image from "../common/Image";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

const AuthDataFormLayout = ({ children }) => {
  const navigate = useNavigate();
  const { language, setLanguage } = useLanguage();

  return (
    <div className="w-full min-h-screen bg-gray-100">
      <div className="w-full h-20 nav-bg flex items-center px-6 justify-between">
        <Image src={logoImg} alt="Logo" className="h-16 object-cover" />
        <div className="flex items-center gap-2 mr-4">
          <span className="text-sm text-white">English</span>

          <button
            type="button"
            onClick={() => setLanguage(!language)}
            className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors
      ${language ? "bg-gray-300" : "bg-gray-300"}`}
          >
            <span
              className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform
        ${language ? "translate-x-6" : "translate-x-1"}`}
            />
          </button>

          <span className="text-sm text-white">हिंदी</span>
        </div>
      </div>
      <div className="w-full bg-light p-6 space-y-4">{children}</div>
    </div>
  );
};

export default AuthDataFormLayout;
